import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { 
  IScoreConversionTable, 
  ICreateScoreConversionTableRequest 
} from "./types";

/**
 * Score Conversion Table 생성 API 함수
 * @param data 생성할 Score Conversion Table 데이터
 * @returns API 응답 객체
 */
export const apiCreateScoreConversionTable = async (
  data: ICreateScoreConversionTableRequest
) => {
  const response = await apiPost<IScoreConversionTable>(
    "/score_conversion_tables", 
    data
  );
  return response.data;
};

/**
 * Score Conversion Table 생성 Mutation Hook
 */
export const useCreateScoreConversionTableMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiCreateScoreConversionTable,
    onSuccess: () => {
      // 목록 쿼리 무효화하여 새로고침
      queryClient.invalidateQueries({
        queryKey: QueryKeys.scoreConversionTable.list(),
      });
    },
  });
}; 